import { useContext } from 'react';
import { SignInContext } from '@modules/users';
import type { TRegistrationScope } from '../helpers/registrationQueries';

export const useRegistrationScope = (): TRegistrationScope => {
  const { organization, user } = useContext(SignInContext);
  return { organizationId: organization._id, userId: user._id };
};
